<template>
  <div
    class="d-flex flex-column justify-content-center align-items-center min-vh-100 p-3"
    style="background-color: #f8f9fa"
  >
    <!-- Card thông tin để test -->
    <div class="test-card p-4 text-center mb-4">
      <h2 class="fw-bold mb-2 text-uppercase" style="font-size: 18px">
        Demo Popup Xác Nhận Ngân Lượng
      </h2>
      <p class="text-muted mb-4" style="font-size: 14px">
        Nhấn nút bên dưới để mở popup xác nhận Ngân Lượng (4 bước)
      </p>

      <b-button
        variant="primary"
        class="fw-bold px-4 py-2"
        style="border-radius: 10px"
        @click="openPopup"
      >
        Mở Popup Xác Nhận
      </b-button>
    </div>

    <!-- Query params preview -->
    <div class="test-card p-3 w-100 text-start" style="max-width: 480px; font-size: 13px">
      <p
        class="fw-bold mb-2 text-muted text-uppercase"
        style="font-size: 11px; letter-spacing: 0.5px"
      >
        Tham số test
      </p>
      <table class="w-100">
        <tbody>
          <tr>
            <td class="text-muted pe-3 pb-1">Id</td>
            <td class="fw-bold pb-1">{{ query.contractId || '—' }}</td>
          </tr>
          <tr>
            <td class="text-muted pe-3 pb-1">appendixId</td>
            <td class="fw-bold pb-1">{{ appendixId || '—' }}</td>
          </tr>
          <tr>
            <td class="text-muted pe-3 pb-1">typeAppendix</td>
            <td class="fw-bold pb-1">{{ typeAppendix || '—' }}</td>
          </tr>
          <tr>
            <td class="text-muted pe-3 pb-1">signStatus</td>
            <td class="fw-bold pb-1">{{ signStatus || '—' }}</td>
          </tr>
          <tr>
            <td class="text-muted pe-3 pb-1">state</td>
            <td class="fw-bold pb-1">{{ state || '—' }}</td>
          </tr>
          <tr>
            <td class="text-muted pe-3 pb-1">email</td>
            <td class="fw-bold pb-1">{{ email || '—' }}</td>
          </tr>
          <tr>
            <td class="text-muted pe-3 pb-1">mobile</td>
            <td class="fw-bold pb-1">{{ mobile || '—' }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Popup component -->
    <PopupConfirmNganLuong
      ref="popupRef"
      :id="appendixId"
      :email="email"
      :mobile="mobile"
      :token="token"
      @hide="onPopupHide"
    />

    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true" />

    <div class="footer-section text-center mt-4" style="font-size: 12px">
      <p class="text-uppercase mb-1 text-center" style="color: #666">
        CÔNG TY CỔ PHẦN CÔNG NGHỆ VI MÔ
      </p>
      <p class="text-center">
        Tầng 12A, toà nhà VTC Online, số 18 Tam Trinh,<br />phường Tương Mai, Hà Nội
      </p>
      <p class="text-center">
        Hotline: <a href="tel:1900636488">1900.63.64.88</a> | Email:
        <a href="mailto:hotro@mpos.vn">hotro@mpos.vn</a>
      </p>
    </div>
  </div>
</template>

<script>
  import PopupConfirmNganLuong from './index.vue'
  import { ContractService } from '@/services/contract.service'

  export default {
    name: 'PopupConfirmTestPage',
    components: {
      PopupConfirmNganLuong,
    },
    data() {
      return {
        query: {
          contractId: '',
        },
        mobile: '',
        email: '',
        appendixId: '',
        typeAppendix: '',
        signStatus: '',
        state: '',
        showLoading: false,
        token: '',
      }
    },
    created() {
      this.query.contractId = this.$route.query.contractId || ''
    },
    mounted() {
      if (this.query.contractId) {
        this.fetchData()
      } else {
        this.showFailMx('Vui lòng điền thêm query contractId')
      }
      this.token = localStorage.getItem('token')
    },
    methods: {
      async fetchData() {
        try {
          this.showLoading = true
          const res = await ContractService.getDetailContractByID({
            contractId: this.query.contractId,
          })
          if (res.code === 1000) {
            this.mobile = res.data?.customerInfoCommon?.mobile || ''
            this.email = res.data?.customerInfoCommon?.email || ''
            this.appendixId = res.data?.lstAppendixNganluongConverts?.[0].appendixId || ''
            this.typeAppendix = res.data?.lstAppendixNganluongConverts?.[0].typeAppendix || ''
            this.signStatus = res.data?.lstAppendixNganluongConverts?.[0].signStatus || ''
            this.state = res.data?.lstAppendixNganluongConverts?.[0].state || ''
          } else {
            this.showFailMx(res.message ?? res.error)
          }
        } catch (error) {
          this.showFailMx(error.response?.data?.message ?? error.message)
        } finally {
          this.showLoading = false
        }
      },
      openPopup() {
        this.$refs.popupRef.show()
      },
      onPopupHide(isSuccess) {
        if (isSuccess) {
          this.showSuccessMx('Xác thực thành công')
        }
      },
    },
  }
</script>

<style>
  @import '~@/assets/css/nganluong.css';
</style>

<style scoped>
  .test-card {
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
    width: 100%;
    max-width: 480px;
  }
</style>
